import { getTranslations } from 'next-intl/server';

import { BlogPageTopic } from '../types';

interface TopicsSectionData {
  title: string;
  description?: string;
  allPostsLabel: string;
  readAnotherPostLabel: string;
}

export const getTopicsSectionData = async (
  topicKey: BlogPageTopic
): Promise<TopicsSectionData> => {
  const t = await getTranslations('article.page.blog');

  switch (topicKey) {
    case BlogPageTopic.TopFive:
      return {
        title: t('articles.topicTitle'),
        allPostsLabel: t('articles.allPostsButton'),
        readAnotherPostLabel: t('articles.readAnotherPost')
      };
    case BlogPageTopic.Wellness:
      return {
        title: t('news.topicTitle'),
        description: t('news.topicDescription'),
        allPostsLabel: t('news.allPostsButton'),
        readAnotherPostLabel: t('news.readAnotherPost')
      };
    case BlogPageTopic.Interview:
      return {
        title: t('videos.topicTitle'),
        allPostsLabel: t('videos.allPostsButton'),
        readAnotherPostLabel: t('videos.readAnotherPost')
      };
  }
};
